import "./Footer.css";
import { useNavigate } from "react-router-dom";
import { Typography } from "@mui/material";

import { clearRedisCache } from "@libs/apiRequest.js";

function Footer() {
  const navigate = useNavigate();

  return (
    <div className="Footer__container">
      <p className="Footer__message">
        Data will be cached for 24 hours. You can also&nbsp;
        <span
          onClick={() => {
            clearRedisCache();
            navigate("/");
          }}
          className="Footer__message--link"
        >
          force reload
        </span>
      </p>
      <div className="Footer__logo--container">
        <Typography
          variant="body2"
          sx={{ color: "#808080", textAlign: "left" }}
        >
          Powered By:
        </Typography>
        <a
          className="Footer__logo--link"
          href="https://www.bimstudio.ca/"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src={`${process.env.PUBLIC_URL}/logo/BIMstudioLogo.svg`}
            alt="Sales & Marketing"
            className="Footer__logo--img"
          />
        </a>
      </div>
    </div>
  );
}

export default Footer;
